import { WEATHER_DATA_FAILURE, WEATHER_DATA_SUCCESS } from '../actions/types/weatherActionTypes';
import WeatherModel from '../../models/WeatherModel';

const initialState = {
  icon: '',
};

export const weatherReducer = (state = initialState, action) => {
  switch (action.type) {
  case WEATHER_DATA_SUCCESS: {
    return new WeatherModel().mapFrom(action.payload);
  }
  case WEATHER_DATA_FAILURE: {
    return new WeatherModel(initialState);
  }

  default:
    return new WeatherModel(state);
  }
};

export default weatherReducer;
